import Dialog from '@mui/material/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeDialog,
  selectWdDialogOptions,
  selectWdDialogState,
} from 'app/store/core/dialogSlice';

function WdDialog(props) {
  const dispatch = useDispatch();
  const state = useSelector(selectWdDialogState);
  const options = useSelector(selectWdDialogOptions);

  return (
    <Dialog
      open={state}
      onClose={(ev) => dispatch(closeDialog())}
      aria-labelledby="Wd-dialog-title"
      classes={{
        paper: 'rounded-8',
      }}
      {...options}
    />
  );
}

export default WdDialog;
